"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RegisterTypeID = void 0;
var RegisterTypeID;
(function (RegisterTypeID) {
    RegisterTypeID["LEVERING_NORMAAL"] = "LN";
    RegisterTypeID["LEVERING_LAAG"] = "LL";
    RegisterTypeID["TERUGLEVERING_NORMAAL"] = "TN";
    RegisterTypeID["TERUGLEVERING_LAAG"] = "TL";
    RegisterTypeID["LEVERING_GAS"] = "LG";
})(RegisterTypeID = exports.RegisterTypeID || (exports.RegisterTypeID = {}));
